import React from 'react';

const About = () => {
    return (
        <div className='pt-28 overflow-x-hidden' id='about'>
            <div className="container mx-auto pb-10">
                <div className='text-center space-y-8'>
                    <h4 data-aos="fade-down" className='uppercase text-lg text-white font-thin tracking-[6px]'>About Me</h4>
                    <h2 data-aos="fade-up" className='text-4xl md:text-6xl color-font'>Creative Independent <br /> Web Developer</h2>
                </div>

                <div className="grid grid-cols-2 gap-4 ">
                    <div data-aos="fade-right" className='col-span-2 lg:col-span-1'>
                        {/* <iframe className='mx-auto w-full h-[300px] sm:h-[500px] bg-transparent' src="https://lottie.host/3dab49d0-33d6-427a-a3a3-b5e7724d835a/aWDmzjoAMC.json"></iframe> */}
                        <iframe title='about' className='mx-auto w-full h-[300px] sm:h-[500px]' src="https://lottie.host/?file=3dab49d0-33d6-427a-a3a3-b5e7724d835a/aWDmzjoAMC.json"></iframe>

                        

                        
                        
                    </div>
                    <div data-aos="fade-left" className='flex flex-col items-center justify-center col-span-2 lg:col-span-1 text-center lg:text-left'>
                        <p className='text-xl text-slate-300 leading-loose tracking-wider'>
                            I am a website designer, and I'm very passionate and dedicated to my work. With more then 2 years experience as a professional web developer, I have acquired the skills and knowledge necessary to make your project a success. I enjoy every step of the design process, from discussion and collaboration.
                        </p>
                    </div>
                </div>

            </div>

            <div className="w-3/5 h-1 bg-gradient-to-l from-neutral-content absolute right-0 z-50"></div>


        </div>
    );
};

export default About;